import TurnaroundModel from "@/models/lab/TurnaroundModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * Turnaround collection
 */
export default class TurnaroundCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return TurnaroundModel;
  }

  publicRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/public/' + model.modelName(),
    }
  }

}
